import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledContainerProps {
  height?: string;
  margintop?: string;
  gap?: number;
}

export const DimensionHighlightContainer = styled(Paper)<StyledContainerProps>(
  ({ theme, height, margintop, gap = 3 }) => ({
    width: '100%',
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(gap),
    height,
    margintop,
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  })
);

export const DimensionHighlightContent = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const StyledDimensionHighlightContentText = styled(Box)(() => ({
  width: '100%',
  maxWidth: '50%',
}));
